<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Remove User From</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Building ___ -->
                    <div class="row m-b-sm" *ngIf="buildingsWithUsers.length > 1">
                        <div class="col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="col-md-8">
                            <select class="form-control" name="buildingId" [ngModel]="building"
                                    (change)="changeBuilding($event.target.value)" required>
                                <option value="" hidden></option>
                                <option *ngFor="let b of buildingsWithUsers" [value]="b.id">
                                    {{b.name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="amenities-filter-items-wrapper" *ngIf="!buildingSelectIsDisabled">
                        <div class="m-b-xs filter-checkbox" *ngFor="let user of usersList; let index = index;">
                            <label class="img-checkbox">
                                <input type="checkbox" id="{{user.id}}" name="{{user.id}}" [(ngModel)]="user.checked">
                                <label for="{{user.id}}"><svg-checked></svg-checked></label>
                                <span>{{user.suiteNumber}}</span>
                            </label>
                        </div>
                    </div>

                    <div class="text-center m-b-md display-flex">
                        <button type="button"
                                (click)="hideModal()"
                                [disabled]="disabledSubmit"
                                class="btn btn-outline-primary submit-btn m-r-sm">
                            Cancel
                        </button>
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/user/delete-user-modal/delete-user-modal.component.html